module.exports = __webpack_public_path__ + "img/globeLightMode.63794854.gif";